export default {
    methods: {
        alphabeticalSort(data) {
            data.sort(function (a, b) {
                var textA = a.value.toUpperCase();
                var textB = b.value.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            return data
        }
    }
}
